"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.onboardingRoutes = void 0;
const onboardingActions_openapi_1 = require("./onboardingActions.openapi");
exports.onboardingRoutes = [
    {
        name: 'onboarding.list',
        path: ['/', '/q/:q'],
        method: 'GET',
        plugins: {
            openapi: onboardingActions_openapi_1.onboardingOpenApiDocs['onboarding.list']
        }
    },
    {
        name: 'onboarding.create',
        path: ['/'],
        method: 'POST',
        plugins: {
            openapi: onboardingActions_openapi_1.onboardingOpenApiDocs['onboarding.create']
        }
    },
    {
        name: 'onboarding.get',
        path: '/:id',
        method: 'GET',
        plugins: {
            openapi: onboardingActions_openapi_1.onboardingOpenApiDocs['onboarding.get']
        }
    },
    {
        name: 'onboarding.update',
        path: '/:id',
        method: 'PUT',
        plugins: {
            openapi: onboardingActions_openapi_1.onboardingOpenApiDocs['onboarding.update']
        }
    },
    {
        name: 'onboarding.delete',
        path: '/:id',
        method: 'DELETE',
        plugins: {
            openapi: onboardingActions_openapi_1.onboardingOpenApiDocs['onboarding.delete']
        }
    },
    {
        name: 'onboarding.profession.steps',
        path: '/profession/:profession_id/steps',
        method: 'GET',
        plugins: {
            openapi: onboardingActions_openapi_1.onboardingOpenApiDocs['onboarding.profession.steps']
        }
    }
];
